import { render } from "./index.vue?vue&type=template&id=4512f36c"
const script = {}
script.render = render

export default script